import React from 'react'
import { Alert } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBadgeCheck,
  faCommentAltTimes,
} from '@fortawesome/pro-solid-svg-icons'
import { useCourse } from 'contexts'
import { useTranslationRankmi } from 'helpers/translations.helper'
import styles from './EvaluationAlert.module.scss'

interface IEvaluationAlert {
  approved: boolean
  points: number
  attempts: number
  correct: string
}

const EvaluationAlert: React.FC<IEvaluationAlert> = ({
  approved,
  points,
  attempts,
  correct,
}) => {
  const t = useTranslationRankmi({
    prefix: 'lessons.contentBlocks.evaluationBlock',
  })
  const { canAnswer, imported } = useCourse()

  const remainingAttempts = !approved && canAnswer
  return (
    <Alert
      className={`${styles.alert} ${
        approved ? styles.approved : styles.failed
      }`}
    >
      <div>
        <FontAwesomeIcon
          className="mr-2"
          icon={approved ? faBadgeCheck : faCommentAltTimes}
        />
      </div>
      <div>
        <b>{t(`resultsModal.${approved ? 'congratulations' : 'pity'}`)}</b>
        {` ${t(`alert.${approved ? 'approvedWith' : 'failedWith'}`)}`}
        {imported
          ? ` ${points} ${t('resultsModal.points')}.`
          : ` ${t(`resultsModal.pointsAndCorrectAnswers`, {
              points,
              correct,
            })}`}
        {remainingAttempts && (
          <b>
            {` ${t(
              `remainingAttempts.${attempts === 1 ? 'singular' : 'plural'}`
            )} ${attempts} `}
            {` ${t(`attempts.${attempts === 1 ? 'singular' : 'plural'}`)}.`}
          </b>
        )}
      </div>
    </Alert>
  )
}

export default EvaluationAlert
